<template>
  <header  class="nav-bar" :class="{'nav-bar-line':border}" :style="{'color':fontColor,'background-color': bgColor}" >
      <div class="nav_left" >
          <template v-if="back">
            <template v-if="$slots.left">
                    <slot name="left"></slot>
            </template>
            <i class="icon-fanhui" v-else  @click="comeback"></i>
          </template>
      </div>
        <div class="nav_middle">
            <template v-if="$slots.default">
                <slot></slot>
            </template>
            <h2 v-else>{{title}}</h2>
         </div>
        <div class="nav_right" :class="{'text':rightType}">
         <slot name="right"></slot>
      </div>
    </header>
</template>
<script>
export default {
    name: 'vNavbar',
    props: {
    title: {
       type: String
    },
    //是否要返回，默认为true
    back: {
      type: Boolean,
      default: true
    },
     //字体颜色
    fontColor: {
       type: String,
       default: "#000"
    },
    //背景颜色
    bgColor: {
       type: String,
       default: "#fff"
    },
    //是否要底部分割线，默认为true
    border: {
      type: Boolean,
      default: false
    },
    //左边类型，true:文本，false为图标
    rightType:{
      type: Boolean,
      default: false
    }
  },
    data() {
        return {
          

        }
    },
    methods: {
      comeback()
      {
        this.$router.go(-1);

      }
    }
}
</script>
<style  scoped>
.nav-bar{height: 49px;position: relative; }
.nav-bar-line{border-bottom: 1px rgb(245, 245, 245) solid;}
.nav-bar .nav_left{ position: absolute;top:0; left: 0; height: 100%; padding-left: 10px; font-size: 2.4rem;display: flex; flex-direction: column; place-content: center;}
.nav-bar .nav_middle{height: 49px; font-size: 1.8rem; display: flex; flex-direction: column; place-content: center;text-align: center;  }
.nav-bar .nav_right{ position: absolute;top:0;right:0; height: 100%; padding-right: 10px; font-size: 2.4rem;display: flex; flex-direction: column; place-content: center;text-align: right; }
.nav-bar .nav_right.text{font-size: 1.6rem;}
.nav-bar .nav_right.text a{color: #fff;}
.nav-bar .nav_middle h2{font-size: 1.8rem; }
</style>



// WEBPACK FOOTER //
// src/components/v-navbar.vue